import React, { useState, useEffect } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../Dialog/Dialog';
import { connect } from 'react-redux';
import {
    Grid,
    IconButton,
    Button,
    InputAdornment,
    MenuItem
} from '@material-ui/core';
import * as logger from '../../../logger';
import { ChargesDeductionsSideBarCss } from './InvoiceSideBarCss';
import { updateChatView } from "../../../store/actions/userActionCreators";
import { getTripDetailsV3, getSingleInvoice } from "../../../store/actions/tripActionCreator";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { Divider } from '@material-ui/core';
import { getMilliDatePickerDateInStringDDMMMYYYY, numberFormat, getVehicleNumberValuesDWeb } from '../../../utils/utils';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import AddChargeDeductionDialog from './AddChargeDeductionDialog';
import DeleteChargeDeductionDialog from './DeleteChargeDeductionDialog';
import { withRouter, useHistory, useLocation } from 'react-router-dom';

const ChargesAndDeductionsSideBar = ({
    open,
    onClose,
    user,
    tripData,
    trip,
    sideBarName,
    dispatchChatView,
    dispatchGetSingleInvoice
}) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [cashFlowItem, setCashFlowItem] = useState(null);
    const [recall, setRecall] = useState(false);
    const [addChargeFlag, setAddChargeFlag] = useState(false);
    const [deleteChargeDeduction, setDeleteChargeDeduction] = useState(false);
    const [transactType, setTransactType] = useState("");
    const [transactData, setTransactData] = useState({});
    const [transactionInfo, setTransactionInfo] = useState([]);

    const classes = ChargesDeductionsSideBarCss();

    const location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let invoiceIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

    useEffect(() => {

        dispatchChatView(false);

    }, [recall]);

    useEffect(() => {

        const tripDataValue = trip && trip.singleInvoiceInfo && trip.singleInvoiceInfo.trips ? trip.singleInvoiceInfo.trips.find(tripInfo => tripInfo.id == tripData.id) : {};

        if (tripDataValue && tripDataValue.transactions && tripDataValue.transactions.charges && tripDataValue.transactions.deductions && tripDataValue.transactions.charges.length > 0 && tripDataValue.transactions.deductions.length > 0) {
            setTransactionInfo(tripDataValue.transactions.charges.concat(tripDataValue && tripDataValue.transactions.deductions ? tripDataValue.transactions.deductions : []));
        } else if (tripDataValue && tripDataValue.transactions && tripDataValue.transactions.charges && tripDataValue.transactions.charges.length > 0) {
            setTransactionInfo(tripDataValue.transactions.charges);
        } else if (tripDataValue && tripDataValue.transactions && tripDataValue.transactions.deductions && tripDataValue.transactions.deductions.length > 0) {
            setTransactionInfo(tripDataValue.transactions.deductions);
        }

    }, [tripData, trip.singleInvoiceInfo]);



    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        dispatchChatView(true);
    }

    const onDeletePartyTransaction = (item) => {
        setCashFlowItem(item);
        if (item && item.amount && item.amount < 0) {
            setDeleteChargeDeduction(true);
            setTransactType("Deduction");
        } else if (item && item.amount && item.amount > 0) {
            setDeleteChargeDeduction(true);
            setTransactType("Charge");
        }
    }

    const handleAddCharge = () => {
        setAddChargeFlag(true);
        setTransactData({});
    }

    const handleChargeDeductionDialogClose = () => {
        setAddChargeFlag(false);
    }

    const handleChargeDeductionDialogConfirm = () => {
        setAddChargeFlag(false);
        recallSingleInvoice();
    }

    const handleDeleteChargeDeductionClose = () => {
        setDeleteChargeDeduction(false);
        setTransactType("");
    }

    const handleDeleteChargeDeductionConfirm = () => {
        setDeleteChargeDeduction(false);
        setTransactType("");
        recallSingleInvoice();
    }

    const handleEditClick = (transactions) => {
        setAddChargeFlag(true);
        setTransactData(transactions);
    }

    const recallSingleInvoice = () => {
        dispatchGetSingleInvoice(invoiceIdValue,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Charges and Deductions Side Bar Dweb", "Get Single Invoice Successfull");
                    setRecall(!recall);
                }
            },
            () => {
                logger.log("Charges and Deductions Side Bar Dweb", "Get Single Invoice Failed");
            }
        );
    }

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={dialogOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >
                <SideBarDialogTitle id={"right-sidebar-for-" + sideBarName ? sideBarName : ''} onClose={handleClose} className={classes.dialogTitle} >
                    <div className={classes.divTitle}>
                        Charges & Deductions
                    </div>
                </SideBarDialogTitle >

                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >

                    {/* Grid trip details container. */}
                    <Grid container className={classes.gridContainerV1} direction="column">
                        <Grid container className={classes.gridV4}>
                            <Grid item className={classes.fw600}>{tripData && tripData.sourceLocation ? tripData.sourceLocation : ""}</Grid>
                            &nbsp;to&nbsp;
                            <Grid item className={classes.fw600}>{tripData && tripData.destinationLocation ? tripData.destinationLocation : ""}</Grid>
                        </Grid>

                        <Grid container className={classes.gridContainerV2} alignItems="center">
                            <Grid item>{tripData && tripData.startDate ? getMilliDatePickerDateInStringDDMMMYYYY(tripData.startDate) : ""}</Grid>
                            <FiberManualRecordIcon className={classes.dotV1} />
                            <Grid item>
                                <div className={classes.divAlign}>
                                    {tripData && tripData.truckNumber && getVehicleNumberValuesDWeb(tripData.truckNumber).map((truckNumber, index) => (
                                        <span className={index != 0 ? classes.mlV1 : ""}>{truckNumber}</span>
                                    ))}
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>

                    <div className={classes.mtV3}>
                        {/* Charges and Deductions List. */}
                        {transactionInfo && transactionInfo.length > 0 && transactionInfo.map((transactions) => (
                            <>
                                <Grid container direction="column" className={classes.gridChargesDeductions} wrap="nowrap">

                                    <Grid container alignItems="center" className={classes.gridV1} wrap="nowrap" justify="space-between">

                                        <Grid container wrap="nowrap" justify="space-between" alignItems="center" className={classes.gridV3}>
                                            <Grid item>
                                                <Grid container direction="column" wrap="nowrap">
                                                    <Grid item className={classes.textV1}>{transactions && transactions.displayName ? transactions.displayName : ""}</Grid>
                                                    <Grid item className={classes.textV2}>{transactions && transactions.date ? getMilliDatePickerDateInStringDDMMMYYYY(transactions.date) : ""}</Grid>
                                                </Grid>
                                            </Grid>

                                            {transactions && transactions.amount > 0 &&
                                                <Grid item className={classes.textV1}>
                                                    {numberFormat(transactions && transactions.amount ? transactions.amount : 0)}
                                                </Grid>
                                            }
                                            {transactions && transactions.amount < 0 &&
                                                <Grid item className={classes.loss}>
                                                    -&nbsp;{numberFormat(transactions && transactions.amount ? transactions.amount * -1 : 0)}
                                                </Grid>
                                            }
                                        </Grid>

                                        <Grid container className={classes.gridV2} wrap="nowrap" alignItems="center" xs={4}>
                                            <Grid item className={classes.mlV2}>
                                                <IconButton className={classes.editButton} onClick={() => handleEditClick(transactions)} >
                                                    <EditIcon className={classes.editIcon} />
                                                </IconButton>
                                            </Grid>
                                            <Grid item className={classes.mlV3}>
                                                <IconButton className={classes.deleteButton} onClick={() => onDeletePartyTransaction(transactions)}>
                                                    <DeleteIcon className={classes.deleteIcon} />
                                                </IconButton>
                                            </Grid>
                                        </Grid>

                                    </Grid>

                                    {transactions && transactions.description &&
                                        <>
                                            <Divider />

                                            <Grid container className={classes.gridContainerV3}>
                                                <Grid item className={classes.gridDescription}>{"\"" + transactions.description + "\""}</Grid>
                                            </Grid>
                                        </>
                                    }

                                </Grid>
                            </>
                        ))}
                    </div>

                    <div className={classes.mtV2}>
                        <Button variant="contained" startIcon={<AddRoundedIcon className={classes.fsV1} />} className={classes.addChargeButton} onClick={() => handleAddCharge()} >
                            Add Charge
                        </Button>
                    </div>

                </SideBarDialogContent>

                <SideBarDialogActions className={classes.dialogActions} >
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()}>
                        Cancel
                    </Button>
                </SideBarDialogActions>

            </Drawer>

            {addChargeFlag && <AddChargeDeductionDialog open={addChargeFlag} tripIdValue={tripData && tripData.id ? tripData.id : ""} tripData={tripData} transactDataValue={transactData} onClose={handleChargeDeductionDialogClose} onConfirm={handleChargeDeductionDialogConfirm} />}
            {deleteChargeDeduction && <DeleteChargeDeductionDialog open={deleteChargeDeduction} tripIdValue={tripData && tripData.id ? tripData.id : ""} deleteId={cashFlowItem && cashFlowItem.id ? cashFlowItem.id : ""} transactTypeValue={transactType} onClose={handleDeleteChargeDeductionClose} onConfirm={handleDeleteChargeDeductionConfirm} />}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchChatView: (value) => dispatch(updateChatView(value)),
    dispatchGetSingleInvoice: (invoiceId, onSuccess, onError) => {
        dispatch(getSingleInvoice(invoiceId, onSuccess, onError))
    }

});
export default connect(mapStateToProps, mapDispatchToProps)(ChargesAndDeductionsSideBar);;